/**
 * Default API body shape for CommonReceiptA5 authless print endpoints.
 * Extracts the first row; returns null when missing (callers show loading until data arrives).
 */
export function selectFirstPrintRow<T>(body: unknown): T | null {
  const rows = (body as { rows?: T[] } | null | undefined)?.rows;
  return rows?.[0] ?? null;
}

/**
 * Lagat print historically used `rows?.[0] || {}` so a successful empty payload
 * still leaves the loading gate and renders an empty receipt.
 */
export function selectFirstPrintRowOrEmpty<T extends object>(body: unknown): T {
  return (selectFirstPrintRow<T>(body) || {}) as T;
}
